import { LOAD_PROJECTS, CREATE_PROJECT, DELETE_PROJECT, UPDATE_PROJECT } from "../actions/projects";
import _ from 'lodash';

export default function (state = [], action) {
    switch (action.type) {
        case LOAD_PROJECTS:
            return action.payload;
        case CREATE_PROJECT:
            state.push(action.payload);
            return state;
        case UPDATE_PROJECT:
            _.remove(state, { _id: action.payload._id });
            state.push(action.payload);
            return state;
        case DELETE_PROJECT:
            var index = 0;
            for (var i = 0; i < state.length; i++) {
                if (state[i]._id === action.payload) {
                    index = i;
                }
            }
            return [...state.slice(0, index), ...state.slice(index + 1)];
        default:
            return state;
    }
}





// WEBPACK FOOTER //
// ./src/reducers/projects.js